import React from 'react';
import { Views, View } from 'react-big-calendar';
import { Skeleton } from 'primereact/skeleton';
import classNames from 'classnames';
import { calendarLocalizer } from '../../utils/calendarUtils';
import { ReservationsCalendarToolbar, ReservationsCalendarToolbarProps } from './ReservationsCalendarToolbar';

export const ReservationsCalendarSkeleton = ({
  currentDate,
  currentView,
  onNavigate,
  onView,
  isFullscreen,
  onToggleFullscreen,
  hiddenWeekdays,
}: {
  currentDate: Date;
  currentView: View;
  onNavigate: ReservationsCalendarToolbarProps['onNavigate'];
  onView: ReservationsCalendarToolbarProps['onView'];
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
  hiddenWeekdays: readonly number[];
}) => {
  return (
    <div className='calendar-skeleton-container'>
      <div className='reservation-calendar-toolbar-container'>
        <div
          className={classNames('rbc-calendar', 'reservation-calendar', 'no-event-label', {
            'big-slots': false,
          })}
        >
          <ReservationsCalendarToolbar
            localizer={calendarLocalizer as unknown as ReservationsCalendarToolbarProps['localizer']}
            date={currentDate}
            view={currentView}
            views={[Views.WEEK, Views.WORK_WEEK, Views.DAY]}
            label=''
            onNavigate={onNavigate}
            onView={onView}
            isFullscreen={isFullscreen}
            onToggleFullscreen={onToggleFullscreen}
            hiddenWeekdays={hiddenWeekdays}
          />
        </div>
      </div>
      <div className='calendar-content'>
        <Skeleton height='900px' />
      </div>
    </div>
  );
};
